export const translation_12_3_A = {
  en: {},
  ko: {
    v1: {
      typography_0: `꾸러미와 느낌`,
      typography_1: `지난 시간에는 경험 꾸러미의 구성 요소 중, '생각'을 명확히 분리하는 방법을 알아봤습니다. 어떤 사건이 일어나면 마음속에서는 생각과 감정, 신체 반응과 행동이 마치 하나의 거대한 덩어리처럼 뒤엉켜 나타납니다. 이 복잡한 덩어리에 압도당하지 않으려면 개별 요소로 풀어내는 과정이 필요합니다.`,
      typography_2: `이제 이 엉킨 경험들 속에서 '감정'과 '신체 반응'을 따로 떼어내 바라보는 연습을 해보겠습니다. 꾸러미에서 생각을 분리하는 것만으로도 마음에 여유가 생기는데, 여기에 감정과 신체 반응까지 구분하면 대상과 한층 더 선명하게 거리를 둘 수 있습니다.`,

      typography_3: `생각의 메아리`,
      typography_4: `감정과 신체 반응은 아무 이유 없이 불쑥 튀어나오지 않습니다. 내면에 품고 있는 '생각'에 반응하여 몸과 마음에 나타나게 됩니다.`,
      typography_5: `내일 중요한 발표를 앞두고 '실수하면 어떡하지?'라는 생각을 했다고 가정해 봅시다. 이 생각은 곧바로 '불안'이라는 감정을 일으키고, '심장 두근거림'이라는 신체 반응으로 이어집니다.`,
      typography_6: `평소 불쾌한 감정이 들 때, 그 감정이 어떤 생각에서 비롯되었는지 쉽게 알아차리는 편인가요?`,

      typography_7: `감정에 이름 붙이기`,
      typography_8: `엉킨 경험에서 '감정'을 떼어내는 법을 알아보겠습니다. 감정을 기록할 때는 '너무 슬퍼서 눈물이 났다'라는 긴 문장 대신, '슬픔'이라는 명사형 단어로 간결하게 이름을 붙이는 것이 좋습니다.`,
      typography_9: `이때 생각이나 행동이 감정과 섞이지 않도록 주의해야 합니다. '저 사람이 나를 무시한다는 느낌'은 감정이 아니라 생각입니다. 순수한 감정 단어만을 따로 떼어내는 것을 연습해야 합니다.`,
      typography_10: `많은 분들이 "내가 느끼는 감정이 뭔지 모르겠다"라고 하시기도 합니다. 이것은 감정에 어떤 것이 있는지 학습이 덜 되었기 때문입니다. 짠맛이 무엇인지 모르는 사람은 결코 '짠맛'을 알아차릴 수 없는 것처럼, 감정을 알아차리려면 어떤 감정이 있는지 먼저 알아두는 것이 큰 도움이 됩니다.`,
      typography_11: `보통 우리가 느끼는 감정들은 크게 분노, 혐오감, 부러움, 두려움, 질투, 슬픔, 수치감, 죄책감, 행복, 사랑이라는 열 가지 카테고리로 나눌 수 있습니다.`,
      typography_12: `그리고 그 안에는 훨씬 더 섬세하고 구체적인 '하위 감정'들이 포함되어 있습니다. 감정의 큰 갈래와 세부 감정들을 알아두면, 내 마음을 한결 정교하게 관찰할 수 있습니다.`,
      typography_emotion_anger: `화남, 복수심, 약오름, 짜증, 적대감`,
      typography_emotion_disgust: `역겨움, 증오, 경멸, 불쾌함, 반감, 멸시`,
      typography_emotion_envy: `시기, 열망, 씁쓸함, 선망, 샘남, 아쉬움`,
      typography_emotion_fear: `공포, 불안, 걱정, 놀람, 공황, 초조함`,
      typography_emotion_jealousy: `집착, 경쟁심, 경계심, 소유욕, 시샘`,
      typography_emotion_sadness: `우울, 절망, 외로움, 서러움, 실망, 패배감`,
      typography_emotion_shame: `당혹감, 굴욕, 창피함, 민망함, 모멸감`,
      typography_emotion_guilt: `미안함, 후회, 안쓰러움, 회한, 자책감`,
      typography_emotion_happiness: `기쁨, 만족, 설렘, 편안함, 희망, 자긍심`,
      typography_emotion_love: `흠모, 애착, 배려, 우애, 연민, 친밀감`,
      typography_13: `물론 감정을 앞으로 분리해 낼 때에 상위 감정과 하위 감정을 명확히 구분하여 적을 필요는 없습니다. 위의 단어들을 활용하여 분리해내기만 하면 됩니다.`,
      typography_14: `친구가 내 인사에 답하지 않는 상황에서 '나를 싫어하는 게 분명해'라는 생각이 떠올랐습니다. 이때 발생할 수 있는 '감정'으로 알맞게 적힌 것은 무엇일까요?`,
      typography_quiz_incorrect: `활동지를 천천히 살펴본 뒤 다시 답해보세요.`,
      typography_15: `정답은 B입니다. A는 '나는 초라하다'라는 생각이며, C는 곧 살펴볼 신체 반응입니다. 감정은 '분노', '슬픔' 등 단어로 적어야 합니다.`,

      typography_16: `몸의 감각 알아차리기`,
      typography_17: `감정에 이름을 붙여보았다면, 이번에는 몸에서 일어나는 감각인 '신체 반응'을 살펴볼 차례입니다. 신체 반응 역시 문장이 아닌 명사형으로 간결하게 적는 것이 원칙입니다.`,
      typography_18: `신체 반응을 적을 때는 충동적인 행동과 헷갈리지 않도록 조심해야 합니다. '당장 도망치고 싶음'은 신체 반응이 아니라 충동(행동)입니다. '가슴의 답답함', '손에 땀이 남'처럼 오로지 몸에서 느껴지는 감각만을 분리해 내야 합니다.`,
      typography_19: `감정과 마찬가지로, 신체 반응 또한 어떤 감각들이 있는지 많이 알고 있을수록 잘 알아차릴 수 있습니다. 연습이 되기 전까지는 다음의 예시를 참고하는 것이 도움이 될 것입니다.`,
      typography_body_head: `지끈거림, 열감, 멍해짐`,
      typography_body_face: `화끈거림, 근육 경련, 무거워짐`,
      typography_body_neck: `긴장됨, 조이는 느낌, 이물감`,
      typography_body_chest: `두근거림, 숨이 가빠짐, 답답함`,
      typography_body_stomach: `울렁거림, 뒤틀림, 더부룩함`,
      typography_body_arm: `떨림, 땀이 남, 손끝 저림`,
      typography_body_leg: `힘 빠짐, 덜덜 떨림, 발끝 저림`,
      typography_20: `다음 중 '신체 반응'을 가장 알맞게 표현한 것은 무엇일까요?`,
      typography_21: `정답은 B입니다. A는 생각과 감정이 섞인 문장형이고, C는 신체 반응이 아니라 행동하려는 충동입니다. '가슴의 답답함'처럼 몸에서 일어나는 순수한 반응을 명사형으로 적는 것이 올바른 분리 방법입니다.`,
      typography_22: `다음 중 '생각'과 '신체 반응'이 알맞게 짝지어진 것을 고르세요.`,
      typography_23: `정답은 C입니다. A와 B에 적힌 '불안함'과 '외로움'은 신체 반응이 아니라 감정입니다. '호흡이 가빠짐', '근육의 긴장', '손의 땀' 등이 신체 반응에 해당합니다.`,

      // 정리 섹션: 기존 key(typography_24/26)는 배포 이전 저장본 호환용으로 유지, 현재 템플릿은 _v2 사용
      typography_24: `직접 해보기`,
      typography_24_v2: `정리하기`,
      typography_25: `지금까지 엉킨 경험 속에서 감정과 신체 반응을 어떻게 분리하는지 살펴봤습니다. 처음에는 뒤엉켜 있는 이 요소들을 구별하는 것이 쉽지 않을 겁니다.`,
      typography_26: `하지만 생각을 먼저 떼어낸 뒤, 그 생각에 따라 느껴지는 감정과 신체 반응에 명사형으로 이름을 붙이는 연습을 반복하면 점차 마음을 들여다보는 시야가 맑아질 것입니다. 이제 이 원리를 실습을 통해 적용해보겠습니다.`,
      typography_26_v2: `하지만 생각을 먼저 떼어낸 뒤, 그 생각에 따라 느껴지는 감정과 신체 반응에 명사형으로 이름을 붙이는 연습을 반복하면 점차 마음을 들여다보는 시야가 맑아질 것입니다.`,
      // 아래 key 들은 현재 템플릿에서 제거되었지만, 배포 이전 저장된 활동지 호환을 위해 유지
      typography_27: `지난 시간에 나를 힘들게 했던 꾸러미를 촉발한 상황을 찾고, 그 순간의 생각을 꾸러미로부터 분리해 보았지요. 그 상황으로 다시 돌아가 보세요.`,
      typography_28: `그리고 그 상황 속에서 어떤 생각이 튀어올랐는지 다시 알아차려 적어봅니다.`,
      typography_29: `이제 그 생각에 반응해 마음에 어떤 감정이 일었는지 천천히 떠올려 적어보세요.`,
      typography_30: `그 당시 몸에는 어떤 신체 반응이 스쳐 지나갔는지 천천히 떠올려 적어보세요.`,
      typography_31: `좋습니다. 코치 선생님이 확인 후 피드백 남겨주실 겁니다.`,
    },
  },
};
